module.exports = __webpack_public_path__ + "img/phone1.4c91cb22.png";